import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchCallHistory = createAsyncThunk(
  "callHistory/fetchCallHistory",
  async (payload, { rejectWithValue }) => {
    try {
      console.log(payload, "payloadforcallapi");

      const response = await api.post("/call/company-call-history", payload);
      console.log(response.data, "responsefromcallapi");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const CallHistorySlice = createSlice({
  name: "callHistory",
  initialState: {
    loading: false,
    fetchAndStoreLoading: false,
    data: [],
    pagination: {
      page: 1,
      page_size: 10,
      total: 0,
    },
    error: null,
  },
  reducers: {
    setFetchAndStoreLoading: (state, action) => {
      state.fetchAndStoreLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallHistory.fulfilled, (state, action) => {
        state.loading = false;

        state.data = action.payload.callRecords || [];

        state.summary = action.payload.summary || {};

        state.pagination = {
          page: action.payload.page || 1,
          page_size: action.payload.page_size || 10,
          total: action.payload.totalRecords || 0,
        };

        state.error = null;
      })
      .addCase(fetchCallHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { setFetchAndStoreLoading } = CallHistorySlice.actions;
export default CallHistorySlice.reducer;
